var exports = {
  "kL": "xa15a2ab7--7d70d7--container",
  "nf": "xa15a2ab7--7d70d7--link",
  "Kk": "xa15a2ab7--7d70d7--icon",
};

module.exports = exports;
